module.exports = __webpack_public_path__ + "static/media/InstitutFr.b92d38df.png";